import React from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { SideBarUserProfile } from './components/side-bar-user-profile';

export const SideBarProfessor: React.FC = observer(() => {
  const createRipple = (event: React.MouseEvent<HTMLDivElement>) => {
    const button = event.currentTarget;
    const ripple = document.createElement('span');
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.style.cssText = `
      position: absolute;
      width: ${size}px;
      height: ${size}px;
      left: ${x}px;
      top: ${y}px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      pointer-events: none;
      animation: ripple 0.6s linear;
      z-index: 1;
    `;

    const style = document.createElement('style');
    style.textContent = `
      @keyframes ripple {
        to {
          transform: scale(2);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    button.appendChild(ripple);

    ripple.addEventListener('animationend', () => {
      ripple.remove();
    });
  };

  return (
    <div
      style={{
        width: '254px',
        marginLeft: '16px',
        minWidth: '254px',
        maxWidth: '254px',
        direction: 'rtl',
        height: '100vh',
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '1px 0 2px rgba(0, 0, 0, 0.05)',
        zIndex: 1000,
        borderLeft: '1px solid var(--surface-200)',
      }}
    >
      <div
        style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid var(--surface-200)',
            backgroundColor: '#ffffff',
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '12px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              backgroundColor: 'var(--primary-color)',
            }}
          >
            <i
              className="pi pi-graduation-cap"
              style={{ color: 'white', fontSize: '1rem' }}
            />
          </div>
          <span
            style={{
              fontFamily: "'Heebo', sans-serif",
              fontSize: '0.95rem',
              fontWeight: 500,
              position: 'relative',
              animation: 'shimmerRightToLeft 4s ease-in-out infinite',
              opacity: 0.9,
            }}
          >
            פורטל מרצים
          </span>
        </div>

        <div
          style={{
            flex: 1,
            overflow: 'auto',
            paddingRight: '16px',
            paddingLeft: '16px',
            paddingTop: '16px',
          }}
        >
          {/* 1. בית */}
          {/*<div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/home"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i className="pi pi-home" style={{ marginLeft: '0.5rem' }}></i>
              <span>בית</span>
            </Link>
          </div>*/}

          <div style={{ height: '16px' }} />

          {/* 2. ההרצאות שלי */}
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/lectures"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i
                className="pi pi-calendar"
                style={{ marginLeft: '0.5rem' }}
              ></i>
              <span>ההרצאות שלי</span>
            </Link>
          </div>

          <div style={{ height: '16px' }} />

          {/* 3. הקורסים שלי */}
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/courses"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i className="pi pi-book" style={{ marginLeft: '0.5rem' }}></i>
              <span>הקורסים שלי</span>
            </Link>
          </div>

          <div style={{ height: '16px' }} />

          {/* 4. המסמכים שלי */}
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/documents"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i className="pi pi-file" style={{ marginLeft: '0.5rem' }}></i>
              <span>המסמכים שלי</span>
            </Link>
          </div>

          <div style={{ height: '16px' }} />

          {/* 5. תעריפי הוראה */}
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/teaching-rates"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i
                className="pi pi-money-bill"
                style={{ marginLeft: '0.5rem' }}
              ></i>
              <span>תעריפי הוראה</span>
            </Link>
          </div>

          <div style={{ height: '16px' }} />

          {/* 6. משכורות */}
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/professor/salaries"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i className="pi pi-wallet" style={{ marginLeft: '0.5rem' }}></i>
              <span>משכורות</span>
            </Link>
          </div>
        </div>
      </div>

      <SideBarUserProfile />
    </div>
  );
});
